<template>
  <div class="navbar">

    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
    />

    <div class="right-menu">
      <!-- v-if="introduction.isAdmin == true" -->
      <el-dropdown
        class="avatar-container right-menu-item"
        style="margin-right: 0;font-size: 12px;max-width: 250px;padding-right: 0;"
        trigger="click"
      >
        <span class="el-dropdown-link">
          <i
            class="el-icon-user"
          /> {{ currentHotelName }}<i
            class="el-icon-arrow-down el-icon--right"
          />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item) in hotelList"
            :key="item.id"
            :disabled="currentHotelId == item.id"
            @click.native="selectHotel(item.id)"
          >{{ item.name }}--{{ item.accountName }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" style="font-size:12px">
        <span class="el-dropdown-link">
          操作<i
            class="el-icon-arrow-down el-icon--right"
          />
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item v-if="!introduction.isAdmin" @click.native="openDialogPwd">修改密码</el-dropdown-item> -->
          <el-dropdown-item @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- <el-dialog
      v-loading="loading"
      title="修改密码"
      :visible.sync="dialogStatusPwd"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @closed="closeDialogPwdProcess"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="setPwd"
        label-position="right"
        label-width="100px"
        style="width: 95%;margin-left:20px; "
      >
        <el-col :span="12">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="原密码" prop="oldPwd">
                <el-input v-model="setPwd.oldPwd" placeholder="原密码" show-password />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="新密码" prop="newPwd">
                <el-input v-model="setPwd.newPwd" placeholder="新密码" show-password />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="重复新密码" prop="newPwdRe">
                <el-input v-model="setPwd.newPwdRe" placeholder="重复新密码" show-password />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogPwd">
          取消
        </el-button>
        <el-button type="primary" @click.native="changePwd()">
          确定
        </el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import nxTopLock from '@/components/nx-top-lock'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import {
  getCurrnetMerchant,
  getCurrentHotel,
  getSubIdentities,
  getCustomBase64,
  setCustomBase64,
  setCurrnetMerchant,
  setCurrentHotel,
  getIntroduction,
  setIntroduction, removeCustomBase64, getCurrentMerchantIndex, getCurrentHotelId, setCurrentHotelId
} from '../../utils/auth'
import store from '@/store'
import Cookies, { set } from 'js-cookie'
import { addMerchant, editMerchant, getMerchantById } from '@/api/global'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    // ErrorLog,
    Screenfull,// eslint-disable-line
    SizeSelect,// eslint-disable-line
    Search,// eslint-disable-line
    // nxTopLock
  },
  data() {
    const checkNewPwdRe = (rule, value, callback) => {
      if (value !== this.setPwd.newPwd) {
        callback(new Error('重复新密码输入不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      submitLock: false,
      temp: {},
      rules: {
        oldPwd: [
          { required: true, message: '请输入原密码', trigger: ['blur', 'change'] },
          { min: 6, message: '密码长度至少6位', trigger: ['blur', 'change'] }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: ['blur', 'change'] },
          { min: 6, message: '密码长度至少6位', trigger: ['blur', 'change'] }
        ],
        newPwdRe: [
          { required: true, message: '请重复输入新密码', trigger: ['blur', 'change'] },
          { min: 6, message: '密码长度至少6位', trigger: ['blur', 'change'] },
          { validator: checkNewPwdRe, trigger: ['blur', 'change'] }
        ]
      },
      merchantList: [],
      hotelList: [],
      currentMerchantIndex: 0,
      currentHotelId: 0,
      introduction: {},
      dialogStatusPwd: false, // 修改密码的弹框显示
      oldPwdRecord: '', // 记录下旧密码
      setPwd: {
        oldPwd: '', // 用户输入的旧密码 拿这个去和oldPwdRecord对比
        newPwd: '', // 用户输入的新密码
        newPwdRe: '' //  用户输入的重复新密码
      },
      currentHotelName: ''
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ])
  },
  inject: ['reload'],
  created() {
    // 设置用户当前酒店信息
    this.introduction = JSON.parse(getIntroduction())
    if (this.introduction && this.introduction.accountIdentities.length > 0) {
      this.hotelList = this.introduction.accountIdentities.map(x => {
        return {
          id: x.hotelID,
          name: x.hotelName,
          accountName: x.accountName
        }
      })
      console.log('hotelList', this.hotelList)
      this.currentHotelId = +getCurrentHotelId()
      if (this.currentHotelId) {
        var hotel = this.hotelList.find(x => x.id === +this.currentHotelId)
        this.currentHotelName = hotel.name + '--' + hotel.accountName
      } else {
        const hasCustomBase64 = getCustomBase64()
        if (hasCustomBase64) {
          var currentHotel = JSON.parse(Buffer.from(hasCustomBase64, 'base64'))
          this.currentHotelId = currentHotel.hotelID
          setCurrentHotelId(currentHotel.hotelID)
          this.currentHotelName = currentHotel.hotelName + '--' + currentHotel.accountName
        }
      }

      // }
    } else {
      console.log('没有获取到酒店信息')
    }
    // 获取所有商店信息
    // this.$store.dispatch('global/getMerchantList').then((res) => {
    //   // this.currentMerchantIndex = Cookies.get('merchantIndex') ? Cookies.get('merchantIndex') * 1 : 0
    //   // 设置 所有门店列表
    //   this.merchantList = res
    //   // console.log('Navbar - merchantList', res)
    //   // console.log('Navbar - res(merchantList) find', res.find(item => item.id === 1))
    //   // 初始化时默认选中的门店 的 index 用于右上角显示名字
    //   // 为管理员时 ==============================
    //   // 设置选中门店索引 去读取cookie内的 currentMerchantIndex 值, 如果有值, 取用该值作为索引
    //   // 如果没有值, 取introduction内的ID, 取得该ID对应的对象在数组中的索引位置
    //   // 为商户时 ================================
    //   // 取introduction内的ID, 取得该ID对应的对象在数组中的索引位置
    //   if (this.introduction.isAdmin === true) {
    //     // 为管理员时 ==============================
    //     const cookieCurrentMerchantIndex = getCurrentMerchantIndex()
    //     console.log(`Navbar.vue cookieCurrentMerchantIndex: ${cookieCurrentMerchantIndex}`)
    //     if (cookieCurrentMerchantIndex) {
    //       this.currentMerchantIndex = cookieCurrentMerchantIndex * 1
    //     } else {
    //       res.forEach((item, index) => {
    //         if (item.id === this.introduction.id) {
    //           // console.log('Navbar - merchantList foreach item', item, index)
    //           this.currentMerchantIndex = index
    //         }
    //       })
    //     }
    //   } else {
    //     // 为商户时 ================================
    //     res.forEach((item, index) => {
    //       if (item.id === this.introduction.id) {
    //         // console.log('Navbar - merchantList foreach item', item, index)
    //         this.currentMerchantIndex = index
    //       }
    //     })
    //   }

    //   // 设置真正的身份
    //   // 为管理员时 ==============================
    //   // 去读取merchantInfo看有没有进行cross 如果有就保留该身份 如果没有直接将管理员作为主身份
    //   // 为商户时 ================================
    //   // 直接将introduction 作为身份
    //   if (this.introduction.isAdmin === true) {
    //     const cookieMerchant = getCurrnetMerchant()
    //     let currnetMerchant
    //     console.log(`Navbar.vue cookieMerchant: ${cookieMerchant}, type of cookieMerchant: ${typeof cookieMerchant}`)
    //     if (cookieMerchant.length > 10 && JSON.parse(cookieMerchant)) {
    //       currnetMerchant = JSON.parse(cookieMerchant)
    //     } else {
    //       currnetMerchant = this.merchantList.find(item => item.id === this.introduction.id)
    //     }
    //     console.log('Navbar.vue currnetMerchant: ', currnetMerchant, `type of cookieMerchant: ${typeof currnetMerchant}`)
    //     console.log('当前选择商家', currnetMerchant)
    //     setCurrnetMerchant(currnetMerchant)

    //     // 获取浏览器
    //     var browser = navigator.userAgent.toLowerCase()
    //     var browserTxt = ''
    //     if (browser.match(/rv:([\d.]+)\) like gecko/)) {
    //       browserTxt = 'ie'
    //     } else if (browser.match(/msie ([\d.]+)/)) {
    //       browserTxt = 'ie'
    //     } else if (browser.match(/firefox\/([\d.]+)/)) {
    //       browserTxt = 'firefox'
    //     } else if (browser.match(/chrome\/([\d.]+)/)) {
    //       browserTxt = 'chrome'
    //     } else if (browser.match(/opera.([\d.]+)/)) {
    //       browserTxt = 'opera'
    //     } else if (browser.match(/version\/([\d.]+).*safari/)) {
    //       browserTxt = 'safari'
    //     } else {
    //       browserTxt = 'other'
    //     }

    //     currnetMerchant.userOS = navigator.userAgent
    //     currnetMerchant.browser = browserTxt
    //     currnetMerchant.userIP = localStorage.getItem('ip')

    //     var customBase64 = new Buffer(JSON.stringify(currnetMerchant)).toString('base64')
    //     setCustomBase64(customBase64)
    //   } else {
    //     setCurrnetMerchant(getIntroduction())
    //   }
    // }).catch((err) => {
    //   console.log('商家列表获取失败', err)
    // })
  },
  methods: {
    // async selectMerchant(idx) {
    //   // 当前选择的商户ID在 商户列表中的索引位置
    //   this.currentMerchantIndex = idx
    //   Cookies.set('currentMerchantIndex', idx)
    //   // 当前商户的身份信息
    //   const currnetMerchant = this.merchantList[idx]
    //   console.log('当前选择商家', currnetMerchant)
    //   setCurrnetMerchant(currnetMerchant)

    //   // 获取浏览器
    //   var browser = navigator.userAgent.toLowerCase()
    //   var browserTxt = ''
    //   if (browser.match(/rv:([\d.]+)\) like gecko/)) {
    //     browserTxt = 'ie'
    //   } else if (browser.match(/msie ([\d.]+)/)) {
    //     browserTxt = 'ie'
    //   } else if (browser.match(/firefox\/([\d.]+)/)) {
    //     browserTxt = 'firefox'
    //   } else if (browser.match(/chrome\/([\d.]+)/)) {
    //     browserTxt = 'chrome'
    //   } else if (browser.match(/opera.([\d.]+)/)) {
    //     browserTxt = 'opera'
    //   } else if (browser.match(/version\/([\d.]+).*safari/)) {
    //     browserTxt = 'safari'
    //   } else {
    //     browserTxt = 'other'
    //   }

    //   currnetMerchant.userOS = navigator.userAgent
    //   currnetMerchant.browser = browserTxt
    //   currnetMerchant.userIP = localStorage.getItem('ip')

    //   var customBase64 = new Buffer(JSON.stringify(currnetMerchant)).toString('base64')
    //   setCustomBase64(customBase64)
    //   this.$message({
    //     message: '已切换商家',
    //     type: 'success',
    //     duration: 2000
    //   })
    //   store.dispatch('tagsView/delAllViews')
    //   // 清掉rules
    //   await this.$store.dispatch('user/clearRoles')
    //   console.log('Navbar.vue 开始执行reload')
    //   // this.reload()
    //   // this.$router.currentRoute.fullPath === "/dashboard"
    //   // 如果当前已经在首页 切换身份还是去首页 这样不会触发vue-route 的 beforeeach
    //   // 所以从判断当前path为首页时 用中间页面过渡处理一下
    //   console.log('Navbar.vue this.$router.currentRoute.fullPath, 当前页面路由为', this.$router.currentRoute.fullPath)
    //   if (this.$router.currentRoute.fullPath === '/dashboard') {
    //     this.$router.push(`/navigator/to-dashboard`)
    //   } else {
    //     this.$router.push(`/dashboard`)
    //   }
    // },

    async selectHotel(id) {
      this.currentHotelId = id
      // Cookies.set('currentHotelId', id)
      setCurrentHotelId(id)
      // 当前酒店的身份信息
      var currentHotel = this.introduction.accountIdentities.find(x => x.hotelID === id)
      // var currentHotel = this.hotelList.find(x => x.id === id)
      console.log('当前选择酒店', currentHotel)
      this.currentHotelName = currentHotel.hotelName
      setCurrentHotel(currentHotel)
      var customBase64 = new Buffer(JSON.stringify(currentHotel)).toString('base64')
      setCustomBase64(customBase64)
      this.$message({
        message: '已切换酒店',
        type: 'success',
        duration: 2000
      })
      store.dispatch('tagsView/delAllViews')
      // 清掉rules
      // await this.$store.dispatch('user/clearRoles')
      // 清掉菜单权限
      await this.$store.dispatch('user/clearMenuIds')
      console.log('Navbar.vue 开始执行reload')

      // this.$router.currentRoute.fullPath === "/dashboard"
      // 在如果当前已经首页 切换身份还是去首页 这样不会触发vue-route 的 beforeeach
      // 所以从判断当前path为首页时 用中间页面过渡处理一下
      console.log('Navbar.vue this.$router.currentRoute.fullPath, 当前页面路由为', this.$router.currentRoute.fullPath)
      if (this.$router.currentRoute.fullPath === '/dashboard') {
        this.$router.push(`/navigator/to-dashboard`)
      } else {
        this.$router.push(`/dashboard`)
      }
    },

    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },

    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },

    // openDialogPwd() {
    //   // 抓取原用户信息
    //   const introduction = JSON.parse(getIntroduction())
    //   if (introduction.isAdmin === true) {
    //     const currnetMerchant = getCurrnetMerchant() ? JSON.parse(getCurrnetMerchant()) : ''
    //     this.merchantID = currnetMerchant && currnetMerchant.id ? currnetMerchant && currnetMerchant.id : ''
    //   } else {
    //     this.merchantID = introduction.id
    //   }
    //   this.$nextTick(() => {
    //     this.loading = true
    //     getMerchantById(this.merchantID).then((res) => {
    //       this.temp = res
    //       // 抓到用户信息后 记录当前密码 并打开弹窗
    //       this.oldPwdRecord = res.pwd
    //       this.dialogStatusPwd = true
    //       this.loading = false
    //     }).catch(() => {
    //       this.$message.error('用户信息获取失败 请稍后再试')
    //     })
    //   })
    // },

    // changePwd() {
    //   if (this.submitLock) {
    //     return
    //   }
    //   this.submitLock = true
    //   this.$refs.dataForm.validate(valid => {
    //     if (valid) {
    //       // 判断原密码是否输入正确
    //       if (this.setPwd.oldPwd !== this.oldPwdRecord) {
    //         this.$message.error('原密码输入错误')
    //         this.submitLock = false
    //         this.loading = false
    //         return false
    //       }

    //       this.loading = true
    //       let params = {}

    //       params = this.temp
    //       params.pwd = this.setPwd.newPwd

    //       editMerchant(this.merchantID, params).then(response => {
    //         console.log(response)
    //         this.loading = false
    //         this.submitLock = false
    //         this.uploadFileList = []

    //         this.dialogStatusPwd = false
    //         this.clearSetPwd()
    //         this.$message({
    //           message: '密码修改成功',
    //           type: 'success',
    //           duration: 2000
    //         })
    //       }).catch((error) => {
    //         this.$notify.error({
    //           title: '错误',
    //           message: error
    //         })
    //         this.loading = false
    //         this.submitLock = false
    //       })
    //     } else {
    //       console.log('error submit!!')
    //       this.submitLock = false
    //       this.loading = false
    //       return false
    //     }
    //   })
    // },

    // closeDialogPwd() {
    //   this.clearSetPwd()
    //   this.dialogStatusPwd = false
    // },

    // closeDialogPwdProcess() {
    //   this.clearSetPwd()
    //   console.log('closeDialogPwdProcess')
    // },

    clearSetPwd() {
      this.setPwd.oldPwd = ''
      this.setPwd.newPwd = ''
      this.setPwd.newPwdRe = ''
    }

  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .nx-help {
    display: inline-block;
    vertical-align: top;
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .show-username {
    line-height: 50px;
    display: inline-block;
    vertical-align: text-bottom;
    padding-left: 10px;
    color: #666;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
